/* global Cookies Foundation */

import URL from "core-js/web/url";

$(document).ready(function () {
    $(".reveal").scroll(function () {
        if ($(".reveal").scrollTop() > 50) {
            $(".mobile-scroll-close").addClass("active");
        } else {
            $(".mobile-scroll-close").removeClass("active");
        }
    });

    /**
     *
     * Logic to check for compliance modals based on cookies
     *
     */
    if ($(".compliance-modal").length) {
        const complianceCheck = Cookies.get("FILCOMPLIANCECOOKIE");

        if (!complianceCheck) {
            $(".compliance-modal").foundation("open");
        }

        $(".fil-modal .compliance-buttons .primary").on("click touch", function () {
            Cookies.set("FILCOMPLIANCECOOKIE", true);
            $(".compliance-modal").foundation("close");
        });
    }

    $(".modal__exit").on("click touch", function () {
        Cookies.set("FILCOMPLIANCECOOKIE", true);
        $(".compliance-modal").foundation("close");
    });

    /**
     *
     * Logic to check if a user is already logged in. if so then open a windown
     *
     */
    $(".buy-funds").click((evt) => {
        evt.preventDefault();
        let isin = $(evt.target).data("isin");
        window.buyFund(isin);
    });

    /**
     * Set up ISIN deep linking on the account opening anchor in the login from
     * tool modal
     *
     * @param {string} isin
     */
    const accountOpeningDeepLink = (isin) => {
        const anchor = $(".login-from-tool a[href*=account-opening]");
        const href = anchor.attr("href");

        if (href) {
            const url = new URL(href);
            url.hash = `/isin:${isin}`;
            anchor.attr("href", url);
        } else {
            // eslint-disable-next-line no-console
            console.warn("No account opening link found in login modal");
        }
    };

    /**
     * Open a login modal deep linking to the buy fund and open account journeys
     *
     * Note: This function *needs* to be available on window as it is called by
     * existing tools rendered in iframes
     *
     * @param {string} isin
     */
    window.buyFund = function (isin) {
        accountOpeningDeepLink(isin);

        let baseURL = window.loginCheckURL || window.location.toString();

        // Login check URL is probably configured to point to the API endpoint, so
        // strip xapi. from the domain to retrieve the URL of the frontend
        baseURL = baseURL.replace("xapi.", "");
        const secureRoute = "/secure/transaktionen/kaufen";

        const secureURL = new URL(secureRoute, baseURL);
        secureURL.protocol = "https";
        secureURL.search = "";
        secureURL.searchParams.set("isin", isin);

        window.openLoginModal(secureURL.toString());
    };

    window.openLoginModal = function (urlLogin) {
        $.getJSON(parent.loginCheckURL, function (data) {
            // Check if the user is already loggedin to the german secure site.
            // if the user is not already loggedin show them a login popup. If the
            // users is logged in, then send them directly to the buy site.

            if (data.login == "true") {
                window.location.href = urlLogin;
            } else {
                window.revealLoginPopup(urlLogin);
            }
        }).fail(function () {
            window.revealLoginPopup(urlLogin);
        });
    };

    window.revealLoginPopup = function (urlLogin) {
        /**
         * Change the link that the login link to point to the secure site
         * including the approriate link.
         */
        let loginCard = parent.$(".login-from-tool a.arrow-right-cta")[1];

        $(loginCard).attr("href", urlLogin);
        parent.$(".login-from-tool").foundation("open");
    };

    let revealModalCounter = 1;
    let revealOverlayZindex = 0;
    let modal;

    $(document).on("open.zf.reveal", "[data-reveal]", function () {
        modal = $(this);
        if (revealOverlayZindex === 0) {
            revealOverlayZindex = modal.parent().css("z-index");
        }

        revealModalCounter = revealModalCounter + 1;
        modal.parent().css("z-index", parseFloat(revealOverlayZindex) + revealModalCounter);
    });

    // TEMPORARY CARD SIZING HACK
    // Cards *always* render with the Foundation grid class medium-4. Howewever,
    // within modals they must instead use the classes medium-6 and fill out the
    // containing grid. This jQuery hack just swaps out the classes and sets the
    // styling as necessary.
    $(".reveal .card-container .card").css("width", "100%");
    $(".reveal .card-container").removeClass("medium-4").addClass("medium-6");

    //show welcome modal if 'welcome=true' in the location search parameter and the modal exist,
    if (location.search.search(/\bwelcome=true\b/i) >= 0) {
        const $welcomeModal = $(".welcome-modal");
        if ($welcomeModal.length && $welcomeModal.foundation) {
            $welcomeModal.foundation("open");
        }
    }
});

function requalize() {
    Foundation.reInit("equalizer");
}

jQuery(document).on("open.zf.reveal", "[data-reveal]", function () {
    if ($("[data-equalizer]", this).length > 0) {
        setTimeout(requalize, 250);
    }
});
